import React, { useEffect, useState, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import "./OptionMenuCollection.scss";
import SaveCollectionModal from "../modals/SaveCollectionModal";
import { ModalContext } from "../ModalContext";
import ProofModal from "../modals/ProofModal";
import {
  collectionDelete,
  assignToCollection,
  unassignFromCollection
} from "../../store/actions/collections";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "utils/helpers";
import { getSelection } from "utils/builder/IScheduleLogic";
import { tabType } from "utils/data";
import { getBounding } from "utils/elementExt";

const OptionMenuCollection = ({
  isOpenMenuCollection,
  closeOptionMenu,
  menuCollectionButtonPosition,
  infoAboutCollection,
}) => {
  const { t } = useTranslation();

  const { handleModal } = useContext(ModalContext);

  const { tabs } = useSelector((state) => state.table);

  const optionMenu = useRef();

  const dispatch = useDispatch();

  const [menuCollectionPosition, setMenuCollectionPosition] = useState(null);
  const [isAssignSelectionButton, setAssignSelectionButton] = useState(null);

  useEffect(async () => {
    const optionMenuClientRect = getBounding(optionMenu.current);
    const heightWindow = document.body.scrollHeight;

    const clientX = menuCollectionButtonPosition?.right + 10;
    let clientY = menuCollectionButtonPosition?.top - 20;

    if (heightWindow - menuCollectionButtonPosition?.y < optionMenuClientRect?.height) {
      clientY = clientY - optionMenuClientRect.height + 60;
    }

    setMenuCollectionPosition({ clientX, clientY });

    const selectionElementsOnViewer = await getSelection();
    setAssignSelectionButton(!!selectionElementsOnViewer.length)

  }, [isOpenMenuCollection]);

  useEffect(() => {

    const checkElement = (event) => {
      const currentElement = event.target;
      const optionMenuElement = optionMenu.current;

      if (!optionMenuElement?.contains(currentElement)) {
        closeOptionMenu();
      }
    }

    document.addEventListener('click', (event) => checkElement(event));

    return (
      document.removeEventListener('click', (event) => checkElement(event))
    )
  }, [isOpenMenuCollection]);

  const handleCancel = () => {
    handleModal(null, true);
  };

  const openEditCollection = () => {
    handleModal(
      <SaveCollectionModal type={"edit"} folderInfo={infoAboutCollection} closeCollectionModal={handleCancel}/>,
      false,
      true
    );
    closeOptionMenu();
  }

  const deleteCollection = async () => {

    try {
      await dispatch(collectionDelete({ tabs, title: infoAboutCollection.title, folder: infoAboutCollection.folder, id: infoAboutCollection.collection.creationTime }));
      showToast(true, t('selection_set_was_deleted'));
    } catch (error) {
      showToast(false, error);
    }

    handleCancel();
  }

  const openProofModal = () => {
    handleModal(
      <ProofModal onCloseModal={handleCancel} proofCallback={deleteCollection} cancelButtonText={t('cancel')} proofButtonText={t('yes_delete')}>
      <div>{t('you_want_delete')} <b>“{infoAboutCollection.title}”</b> {t('collection')}?</div>
      </ProofModal>,
      false,
      true
    );
    closeOptionMenu();
  }

  const assignElements = () => {
    try {
      dispatch(assignToCollection({ title: infoAboutCollection.title, folder: infoAboutCollection.folder, id: infoAboutCollection.collection.creationTime }));
      showToast(true, `${t('assigned_to')} ${infoAboutCollection.title}`);
    } catch (error) {
      showToast(false, t('something_went_wrong'));
    }
    closeOptionMenu();
  }

  const unassignElements = () => {
    dispatch(unassignFromCollection({ ...infoAboutCollection, type: tabType.saved, name: infoAboutCollection.title, id: infoAboutCollection.collection.creationTime }));
    closeOptionMenu();
  }

  return (
    <div className="option-menu-collection-wrapper">
      {
        isOpenMenuCollection &&
        <div className="option-menu-collection" ref={optionMenu}
          style={{ top: menuCollectionPosition?.clientY + "px", insetInlineStart: menuCollectionPosition?.clientX + "px" }}>
          <div className="option" onClick={openEditCollection}>{t('edit')}</div>
          {
            isAssignSelectionButton &&
            <>
              <div className="option" onClick={assignElements}>{t('assign_selection')}</div>
              <div className="option" onClick={unassignElements}>{t('unassign_selection')}</div>
            </>
          }
          <div className="option_red" onClick={openProofModal}>{t('delete')}</div>
        </div>
      }
    </div>
  );
};

export default OptionMenuCollection;